import { render, staticRenderFns } from "./dialog-form.vue?vue&type=template&id=be5a1650&scoped=true&"
import script from "./dialog-form.vue?vue&type=script&lang=js&"
export * from "./dialog-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5a1650",
  null
  
)

export default component.exports